import React from 'react';

import SelectOptionInfo from '../Selects/SelectOptionInfo';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface EmailAdressCommentInfoProps {
  comment?: string;
}

export const EmailAdressCommentInfo: React.FC<
  EmailAdressCommentInfoProps
> = props => {
  const { t, tk } = useTranslation('clientLng');

  return (
    <>
      {!!props.comment && props.comment !== null && (
        <SelectOptionInfo
          label={props.comment}
          title={t(tk.emailAddress.comment)}
          placement="auto"
        />
      )}
    </>
  );
};
